import { GraphQLFormattedError } from "graphql"
import { Variables } from "relay-runtime"
import { RingBuffer } from "ring-buffer-ts"

interface Query {
  id: string
  name: string
  error?: Error | readonly GraphQLFormattedError[]
  text: string
  variables: Variables
  data?: unknown
}

const BUFFER_SIZE = 100 // Maximum number of queries to keep

class QueriesStore {
  private queries: RingBuffer<Query>

  constructor() {
    this.queries = new RingBuffer<Query>(BUFFER_SIZE)
  }

  addQuery(query: Query): void {
    const filteredSensitiveVariables = Object.entries(query.variables)
      .filter(([key]) => key.toLowerCase().endsWith("id") || key.toLowerCase().includes("country"))
      .reduce<Variables>((acc, [key, value]) => {
        acc[key] = value
        return acc
      }, {})

    const newQuery = {
      ...query,
      variables: filteredSensitiveVariables,
    }
    this.queries.add(newQuery)
  }

  getAllQueries(): Query[] {
    return this.queries.toArray()
  }
}

export const queriesStore = new QueriesStore()

export type { Query }
